import type { ReactNode } from 'react';
import { Popover, PopoverContent, PopoverTrigger } from '@savvy-kit/components/popover';
import { cn } from '@savvy-kit/lib/utils';
import { Info } from 'lucide-react';

type InfoBubbleProps = {
  readonly label: string;
  readonly children: ReactNode;
  readonly contentClassName?: string;
};

export function InfoBubble({ label, children, contentClassName }: InfoBubbleProps) {
  return (
    <Popover>
      <PopoverTrigger
        openOnHover
        delay={0}
        aria-label={label}
        className="-my-3.5 -ml-2.5 -mr-3.5 flex size-11 shrink-0 cursor-pointer touch-manipulation items-center justify-center text-secondary hover:text-primary"
      >
        <Info className="size-3.5" aria-hidden="true" />
      </PopoverTrigger>
      <PopoverContent
        className={cn(
          // oxlint-disable-next-line shadcn/no-restyle -- a tooltip that also opens on tap, which the kit Tooltip doesn't
          'w-fit max-w-64 border-0 bg-foreground px-3 py-1.5 text-xs text-balance text-white dark:[background-color:var(--elevation-3)] dark:[color:var(--foreground-light)]',
          contentClassName,
        )}
      >
        {children}
      </PopoverContent>
    </Popover>
  );
}
